// extracted by mini-css-extract-plugin
export default {"content":"InvoiceHistoryDialog_content__xH8pl","card":"InvoiceHistoryDialog_card__HaQsL","iconTypography":"InvoiceHistoryDialog_iconTypography__Vs9lG"};